/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/*jslint white: true */
/*jslint node: true */
/*global $, jQuery, Swiper, ScrollMagic*/

$ = jQuery;

$(document).ready(function () {
	$(".hamburguer").on("click", function () {
		$(".full-menu").toggleClass("active");
		$(".hamburguer").toggleClass("close-hamburguer");
	});

	$(".full-menu a").on("click", function () {
		$(".full-menu").toggleClass("active");
		$(".hamburguer").toggleClass("close-hamburguer");
	});
});
